import axios from 'axios'

export default class Api {
  /*
   * params.station_code: 駅コード (例: 'K22')
   * params.dest_stations: 方面 (例: ['帯広', '釧路'])
   * params.date: 対象日 (例: '2019-03-25')
   * params.since_time: 時刻フィルター (optional, 例: '12:34')
   */
  static async searchSchedules (params) {
    const url = Api.getUrl('/train_schedules')
    const res = await axios.get(url, { params });
    return res.data.train_schedules;
  }

  /*
   * stationCode: 駅コード (例: 'K22')
   */
  static async getStationDetail (stationCode) {
    const url = Api.getUrl(`/target_station_details/${stationCode}`)
    const res = await axios.get(url);
    return res.data.target_station_detail;
  }

  /*
   * stationCode: 駅名 (例: 'tomamu')
   */
  static async getStationConfig (stationName) {
    const res = await axios.get('/config.json')
    return res.data.stations[stationName]
  }

  /*
   * QRサイト側のAPI
   */
  static async getUriMode() {
      const res = await axios.get('/tomamu/info-qr-api/api/getUriMode')
    return res.data.mode
  }

  static getUrl (path) {
    let baseUrl = '/api/v1'
    if (window.location.host === 'localhost:3000') {
      baseUrl = `http://localhost:5000${baseUrl}`
    }
    return baseUrl + path
  }
}